export default __webpack_public_path__ + "static/manage-d14ad36ac8cd4503a79a8c095233e76d.jpg";